// extracted by mini-css-extract-plugin
export default {"input-text":"_ibqFQ75sStWgUfdWhfX","inputText":"_ibqFQ75sStWgUfdWhfX"};